import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { InvDailyFormComponent } from "./inv-daily-header/inv-daily-form/inv-daily-form.component";
import { InvDailyListComponent } from "./inv-daily-header/inv-daily-list/inv-daily-list.component";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { InvDailyRemainFormComponent } from "./inv-daily-remain/inv-daily-remain-form/inv-daily-remain-form.component";
import { InvDailyRemainListComponent } from "./inv-daily-remain/inv-daily-remain-list/inv-daily-remain-list.component";
import { InvDailyWasteFormComponent } from "./inv-daily-waste/inv-daily-waste-form/inv-daily-waste-form.component";
import { InvDailyWasteListComponent } from "./inv-daily-waste/inv-daily-waste-list/inv-daily-waste-list.component";
import { InvDailyWarehouseComponent } from "./inv-daily-warehouse/inv-daily-warehouse.component";
import { InvDailyWasteSettingComponent } from "./inv-daily-waste/inv-daily-waste-setting/inv-daily-waste-setting.component";
import { InvDailyWasteMenuComponent } from "./inv-daily-waste/inv-daily-waste-menu.component";
import { InvDailyListDialogComponent } from "./inv-daily-header/inv-daily-listdialog/inv-daily-listdialog.component";
import { InvCreateInvVoucherListComponent } from "./inv-CreateInvVoucher/inv-CreateInVoucher-list/inv-CreateInvVoucher-list.component";
import { InvCreateInvVoucherFormComponent } from "./inv-CreateInvVoucher/inv-CreateInVoucher-form/inv-CreateInvVoucher-form.component";
import { InvDailyBalanceComponent } from "./inv-daily-balance/inv-daily-balance.component";
import { InvDailySettingComponent } from "./inv-daily-header/inv-daily-setting/inv-daily-setting.component";
import { InvDailyHeaderMenuComponent } from "./inv-daily-header/inv-daily-header-menu.component";
import { InvCreateInVoucherMenuComponent } from "./inv-CreateInvVoucher/inv-createIn-voucher-menu.component";
import { InvCreateInVoucherSettingComponent } from "./inv-CreateInvVoucher/inv-CreateInVoucher-setting/inv-CreateInVoucher-setting.component";
import { InvDailyUsageComponent } from "./inv-daily-usage/inv-daily-usage.component";
const components = [
  InvDailyRemainFormComponent,
  InvDailyRemainListComponent,
  InvDailyWasteFormComponent,
  InvDailyWasteListComponent,
  InvDailyWasteSettingComponent,
  InvDailyWasteMenuComponent,
  InvDailyFormComponent,
  InvDailyListComponent,
  InvDailyWarehouseComponent,
  InvDailyListComponent,
  InvDailyListDialogComponent,
  InvCreateInvVoucherListComponent,
  InvCreateInvVoucherFormComponent,
  InvDailyBalanceComponent,
  InvDailySettingComponent,
  InvDailyHeaderMenuComponent,
  InvCreateInVoucherMenuComponent,
  InvCreateInVoucherSettingComponent,
  InvDailyUsageComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class InvModule {}
